import { useState } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Button } from 'components';
import { useImpersonateInfo, useResetImpersonateAccount, useResetPaymentFilter } from 'state';
import styles from './StopImpersonatingButton.module.scss';

export default function StopImpersonatingButton() {

    const [visible, setVisible] = useState(false);
    const toggleDialog = () => setVisible(!visible);

    const impersonateInfo = useImpersonateInfo();
    const resetImpersonate = useResetImpersonateAccount();
    const resetPaymentFilter = useResetPaymentFilter();
    
    const stopImpersonating = () => {
        resetImpersonate();
        resetPaymentFilter();
        toggleDialog();
    };

    return (
        <>
            <Button
                className={styles.button}
                fillMode="outline"
                themeColor="tertiary"
                onClick={toggleDialog}
            >
                STOP
            </Button>
            {visible && (
                <Dialog 
                    title="Stop Impersonating?"
                    width="30rem"
                    onClose={toggleDialog}
                >
                    <div className={styles.selectedAccount}>
                        <div>
                            Are you sure you want to stop impersonating this account?
                        </div>
                        <div className={styles.supplierName}>
                            {impersonateInfo?.fullName}
                        </div>
                        <div className={styles.supplierNumber}>
                            {impersonateInfo?.accountId}
                        </div>

                    </div>
                    <div className={styles.actionButtons}>
                        <Button
                            fillMode="solid"
                            themeColor="primary"
                            onClick={stopImpersonating}
                        >
                            YES, STOP IMPERSONATING
                        </Button>
                        <Button
                            fillMode="flat"
                            themeColor="primary"
                            onClick={toggleDialog}
                        >
                            NO, CANCEL
                        </Button>
                    </div>
                </Dialog>
            )}
        </>
    )
}